import Swiper from 'swiper';

export default function setInstagramSection() {
  const carousel = document.querySelector('[data-instagram-swiper]');
  const postsContainer = carousel?.querySelector('.swiper-wrapper');
  const posts = postsContainer ? Array.from(postsContainer.children) : [];

  if (posts.length < 2) return;

  [posts[1], posts[0], ...posts.slice(2)].forEach((post) => postsContainer.appendChild(post));

  return new Swiper(carousel, {
    slidesPerView: 3,
    spaceBetween: 0,
    speed: 600,
    watchOverflow: true,
  });
}
